import type { ClientSuggestionWithdrawRequest } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQueryClient } from '@tanstack/react-query';

import { useGrapevineSuggestionEventsApi } from '@/features/api/hooks/grapevine-suggestion-events/useGrapevineSuggestionEventsApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';
import { invalidatePostCachesForDeletedPost } from '@/features/api/utils/postCaches';

export const useWithdrawSuggestion = () => {
  const queryClient = useQueryClient();
  const api = useGrapevineSuggestionEventsApi();

  return useApiMutation({
    mutationFn: (
      clientSuggestionWithdrawRequest: ClientSuggestionWithdrawRequest
    ) => api.onSuggestionWithdrawRequest({ clientSuggestionWithdrawRequest }),
    onSuccess: ({ suggestionId }) =>
      invalidatePostCachesForDeletedPost(queryClient, suggestionId)
  });
};
